import { useCallback } from 'react';
import { useRootNavigation } from './PopNavigatorProvider';
import { AppModalNavigation } from './utils/routeHelpers';

export const useSafeTopNavigation = () => {
  const navigation = useRootNavigation();

  return useCallback(
    (callback: (nav: AppModalNavigation) => void) => {
      // do mobile navigation.
      let nav = navigation;
      let max = 5;

      while (nav != null && max-- > 0) {
        const state = nav.getState();
        if (state == null) break;
        if (state.routeNames.includes('debugPanel')) {
          break;
        }
        nav = nav.getParent();
      }

      if (nav == null) {
        return;
      }

      callback(nav);
    },
    [navigation],
  );
};
